// extracted by mini-css-extract-plugin
module.exports = {"root":"yQ0WR","button":"uNVbF","imageWrapper":"Ffa-x","left":"FYRDp","right":"RCgu6"};